export default __webpack_public_path__ + "static/media/gimnasio.9c1e2baf.svg";